import styles from './sales.module.css';
import { useEffect } from 'react';

type Props = {
  circles: CircleProp[];
  mobileCircles: CircleProp[],
  zIndex: number
}

type CircleProp = {
  x: number,
  y: number,
  type: string,
  side: string
}

const Background = ({ circles, mobileCircles, zIndex = -1 }: Props) => {
  useEffect(() => {
    setInterval(() => {
      resizeCanvas()
    }, 1000);
  })

  const id = Math.random().toString(36).substring(2, 8);

  const resizeCanvas = () => {

    const canvas = document.getElementById(id) as HTMLCanvasElement;;
    if (canvas === null) {
      return null
    }
    const ctx = canvas.getContext('2d');

    const container = document.getElementById('agentContainer') as HTMLCanvasElement;;

    canvas.width = window.outerWidth;
    canvas.height = container.offsetHeight

    let p1x = 0
    const circleTypes = {
      small: new Path2D("M 100 50 C 100 77.613281 77.613281 100 50 100 C 22.386719 100 0 77.613281 0 50 C 0 22.386719 22.386719 0 50 0 C 77.613281 0 100 22.386719 100 50 Z M 27.089844 50 C 27.089844 62.652344 37.347656 72.910156 50 72.910156 C 62.652344 72.910156 72.910156 62.652344 72.910156 50 C 72.910156 37.347656 62.652344 27.089844 50 27.089844 C 37.347656 27.089844 27.089844 37.347656 27.089844 50 Z M 27.089844 50 "),
      medium: new Path2D("M 250 125 C 250 194.03125 194.03125 250 125 250 C 55.96875 250 0 194.03125 0 125 C 0 55.96875 55.96875 0 125 0 C 194.03125 0 250 55.96875 250 125 Z M 67.726562 125 C 67.726562 156.632812 93.367188 182.273438 125 182.273438 C 156.632812 182.273438 182.273438 156.632812 182.273438 125 C 182.273438 93.367188 156.632812 67.726562 125 67.726562 C 93.367188 67.726562 67.726562 93.367188 67.726562 125 Z M 67.726562 125"),
      large: new Path2D("M 400 200 C 400 310.457031 310.457031 400 200 400 C 89.542969 400 0 310.457031 0 200 C 0 89.542969 89.542969 0 200 0 C 310.457031 0 400 89.542969 400 200 Z M 108.355469 200 C 108.355469 250.613281 149.386719 291.644531 200 291.644531 C 250.613281 291.644531 291.644531 250.613281 291.644531 200 C 291.644531 149.386719 250.613281 108.355469 200 108.355469 C 149.386719 108.355469 108.355469 149.386719 108.355469 200 Z M 108.355469 200"),
      xl: new Path2D("M 600 300 C 600 465.683594 465.683594 600 300 600 C 134.316406 600 0 465.683594 0 300 C 0 134.316406 134.316406 0 300 0 C 465.683594 0 600 134.316406 600 300 Z M 162.535156 300 C 162.535156 375.917969 224.082031 437.464844 300 437.464844 C 375.917969 437.464844 437.464844 375.917969 437.464844 300 C 437.464844 224.082031 375.917969 162.535156 300 162.535156 C 224.082031 162.535156 162.535156 224.082031 162.535156 300 Z M 162.535156 300 ")
    }
    const leftBorder = (window.outerWidth - 1240) / 2;
    const rigthBorder = (window.outerWidth + 1240) / 2;


    if (window.outerWidth > 900) {
      circles.forEach(function (circle) {
        p1x = p1x + 1
        if (ctx) {
          ctx.save();
          ctx.strokeStyle = 'rgb(247, 50, 97)';
          ctx.fillStyle = "rgb(247, 50, 97"
          ctx.translate(circle.side === 'left' ? leftBorder - circle.x : rigthBorder - circle.x, circle.y); // Adjust context to where you want to draw p1
          ctx.fill(circleTypes[circle.type]);
          ctx.restore();
        }         // Restore the context before drawing p2
      });
    } else {
      mobileCircles.forEach(function (circle) {
        p1x = p1x + 1
        if (ctx) {
          ctx.save();
          ctx.strokeStyle = 'rgb(247, 50, 97)';
          ctx.fillStyle = "rgb(247, 50, 97"
          ctx.translate(circle.x, circle.y); // Adjust context to where you want to draw p1
          ctx.fill(circleTypes[circle.type]);
          ctx.restore();         // Restore the context before drawing p2
        }
      })
    }



  }

  return <canvas className={styles.canvas} id={id} style={{ zIndex: zIndex }} />

}

export default Background;